import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authQueryKeys, authUserKey } from '../constants'
import { customQueryClient } from '../../config/query-client'
import {
  getLocaleChangedStatic,
  getChangeLocaleStatic
} from '../../../zustand/language/use-language-store'
import { handleSetLocale } from '../../../containers/authentication/utils/set-locale'

export const useMeQuery = (options) => {
  const changeLocale = getChangeLocaleStatic()
  const localeChanged = getLocaleChangedStatic()
  const handleQuery = async () => {
    const config = {
      method: 'get'
    }

    const { data } = await api('/api/me', config)

    handleSetLocale(data, localeChanged, changeLocale)
    return data
  }

  return useQuery({
    queryKey: [authQueryKeys.ME, authUserKey],
    queryFn: handleQuery,
    retry: 0,
    ...options
  })
}

// Actions
export const setUser = (key, data) => {
  customQueryClient.setQueryData(key, data)
}

// Selectors
export const getUser = () => {
  return customQueryClient.getQueryData([authQueryKeys.ME, authUserKey])
}

export const getUserId = () => getUser()?.userId ?? null

export const getEmail = () => getUser()?.email ?? null

export const getLicense = () => getUser()?.license ?? null

export const getTierName = () => getUser()?.subscriptionInfo?.tier?.name ?? null

export const getPermissions = () => getUser()?.permissions ?? null

export const getIsOwner = () => getUser()?.owner ?? false

export const getIsAdmin = () => getUser()?.settings?.admin ?? false

export const getFullName = () => {
  const user = getUser()
  return user ? `${user.firstName} ${user.lastName}` : ''
}

export const getFirstName = () => {
  const user = getUser()
  return user?.firstName ?? ''
}

export const getLasttName = () => {
  const user = getUser()
  return user?.lastName ?? ''
}

export const getOrganizationName = () => getUser()?.organisationName ?? null

export const getOrganizationId = () => getUser()?.organisationId ?? null

export const getNoLicenseMessage = () => getUser()?.noLicenseMessage ?? null
